<template>
	<div class="page">
		<div class="form-title">
			<span>报价单</span>
			<img class="logo" src="../assets/logo.44a85025.png" />
		</div>
		<div class="form-content">
			<el-form ref="dForm" :rules="rules" :model="form" :inline="false" label-width="90px">
				<el-form-item label="公司名称:" prop="company">
					<el-input v-model="form.company"></el-input>
				</el-form-item>
				<el-form-item label="联系方式:" prop="phone">
					<el-input v-model="form.phone"></el-input>
				</el-form-item>
				<el-form-item label="运输方式:" prop="transType">
					<el-radio-group v-model="form.transType">
						<el-radio v-for=" item in transType" :key="item.id" :label="item.value" :value="item.value">
							{{ item.value }}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="货物类型:" prop="goodsType">
					<el-radio-group v-model="form.goodsType">
						<el-radio v-for=" item in goodsType" :key="item.id" :label="item.value" :value="item.value">
							{{ item.value }}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="货物信息:">
				</el-form-item>
				<el-row>
					<el-col :span="6">
						<el-form-item label="货物件数" prop="goodsCount">
							<el-input style="width: 100%;" v-model="form.goodsCount"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="包装种类" prop="packageType">
							<el-input style="width: 100%;" v-model="form.packageType"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="重量" prop="descWeight">
							<el-input style="width: 100%;" v-model="form.descWeight"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="体积" prop="descVolume">
							<el-input style="width: 100%;" v-model="form.descVolume"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="6">
						<el-form-item label="始发地:" prop="departurePoint">
							<el-select v-model="form.departurePoint" filterable placeholder="请选择始发地">
								<el-option v-for="item in beginAddress " :key="item.id" :label="item.value"
									:value="item.value">
									{{ item.value }}
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="口岸:" prop="port">
							<el-select v-model="form.port" filterable placeholder="请选择口岸">
								<el-option v-for="(item, index) in portList" :key="index" :label="item.portName"
									:value="item.portName">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="清关地" prop="clearance">
							<el-select v-model="form.clearance" placeholder="请选择">
								<el-option v-for="(item, index) in deliveryList" :key="index" :label="item.deliveryName"
									:value="item.deliveryName">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="交仓地" prop="delivery">
							<el-select v-model="form.delivery" placeholder="请选择">
								<el-option v-for="(item) in deliveryList" :key="item.deliveryId" :label="item.deliveryName"
									:value="item.deliveryName">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutters="100">
					<el-col :span="2" :offset="6">
						<el-form-item>
							<el-button type="primary" @click="onSubmit">获取报价</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="16">
						<div style="width:100%;height:100%;" class="price" v-show="showAmount">
							￥{{ amount }}
						</div>
					</el-col>
				</el-row>
			</el-form>
		</div>
	</div>
</template>

<script>
import { queryAmount, queryportPage, querydeliveryPage, saveInfo } from "@/api/home";
export default {
	name: 'HomeView',
	data() {
		var checkPhone = (rule, value, callback) => {
			if (value === "") {
				callback(new Error("请输入绑定的手机号码"))

			} else if (!/^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1589]))\d{8}$/.test(value)) {
				callback(new Error("请输入正确的手机号码"))
			} else {
				callback()
			}
		};
		return {
			amount: '',
			form: {
				company: '',
				phone: '',
				goodsCount: '',
				packageType: '',
				descWeight: '',
				goodsVolume: '',
				goodsType: '',
				transType: '',
				port: '', //出境口岸
				clearance: '',
				delivery: '',
				departurePoint: '',
				quotationGmp: 1.15,
				chargesAmount: 0,
				chargesDesc: null
			},
			rules: {
				company: [
					{ required: true, message: '请输入公司名称', trigger: 'blur' }
				],
				phone: [
					{ validator: checkPhone, required: true, trigger: 'blur' },
				],
				transType: [
					{ required: true, message: '请选择运输方式', trigger: 'change' }
				],
				goodsType: [
					{ required: true, message: '请选择货物类型', trigger: 'change' }
				],
			
				departurePoint: [
					{ required: true, message: '请选择始发地', trigger: 'blur' }
				],
				port: [
					{ required: true, message: '请选择口岸', trigger: 'blur' }
				],
				clearance: [
					{ required: true, message: '请选择清关地', trigger: 'blur' }
				],
				delivery: [
					{ required: true, message: '请选择交仓地', trigger: 'blur' }
				]
			},
			deliveryList: [],
			showAmount: false,
			carList: ['98方篷布车', '92方标准篷布车', '105方篷布车', '86方厢车'],
			portList: [],
		
			goodsType: [{
				id: 0,
				value: "普货"
			},
			{
				id: 1,
				value: "锂电池"
			},
			{
				id: 2,
				value: "危险化学品"
			}
			],
			transType: [{
				id: 0,
				value: "公路"
			},
			{
				id: 1,
				value: "铁路"
			},
			{
				id: 3,
				value: "空运"
			},
			{
				id: 4,
				value: "海运"
			}
			],
		
			beginAddress: [{
				id: 0,
				value: "华南"
			},
			{
				id: 1,
				value: "华中"
			},
			{
				id: 2,
				value: "华北"
			},
			{
				id: 3,
				value: "华西"
			}
			],
		}
	},
	created() {
		this.queryport()
		this.querydeliveryPage()
	},
	watch: {
		'form.clearance': function () {
			this.form.delivery = this.form.clearance
		},
		'form.delivery': function () {
			this.form.clearance = this.form.delivery
		}
	},
	methods: {
		onSubmit() {
			this.$refs['dForm'].validate((valid) => {
				if (valid) {
					queryAmount({ ...this.form }).then(res => {
						if (res.data.status == 200) {
							this.showAmount = true
							const { data: { result } } = res
							this.amount = result.amount.toFixed(2)
							return res
						} else {
							this.$message.error(res.data.message);
							this.amount = null
						}
					}).then(res => {
						saveInfo({
							...res.data.result, ...this.form,
						})
					})
				} else {
					return false;
				}
			});

		},
		querydeliveryPage() {
			querydeliveryPage({
				page: 1,
				rows: 0,
				sellers: ''
			}).then((res) => {
				if (res.status == 200) {
					this.deliveryList = res.data.result.list
				}
			})
		},
		//获取口岸数据
		queryport() {
			queryportPage({
				companyId: 0,
				end: 0,
				page: 1,
				portName: "",
				rows: 0,
				start: 0,
				userId: 0
			}).then((res) => {
				if (res.status == 200) {
					this.portList = res.data.result.list
				}
			})
		},
	},

}
</script>

<style scoped>
.page {
	width: 100vw;
	min-width: 1100px;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
}

.head {
	width: 100%;
	min-width: 1100px;
	height: 12px;
	background: #0166ff;
}

.logo {
	width: 221px;
	position: relative;
	left: -350px;
	top: 25px;

}

.el-input {
	width: 450px;
	float: left;
}

.el-radio-group {
	float: left;
	line-height: 50px;
}

.huowu-message {
	width: 100%;
	display: flex;
}

.huowu-message .el-input {
	width: 150px;
	float: right;
	margin-right: 20px;
}

.el-select {
	float: left;
}


.form-title {
	width: 60%;
	font-size: 22px;
	color: #333;
	line-height: 1;
	padding-bottom: 20px;
	border-bottom: 1px solid #ccc;
	margin: 30px 0 20px 0;
	text-align: left;
	font-weight: 600;
}



.form-content {
	width: 60%;
}

.input-address {
	display: flex;
	width: 100%;
	position: relative;
	left: -90px;

}

.price {
	color: red;
	font-size: 30px;
}

.get-btn {
	width: 140px;

}
</style>
